"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1165],{

/***/ 51165:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ CollectingLeads_CollectingLeads; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/blocks/CollectingLeads/Types.ts
var LayoutEnum;
(function(LayoutEnum) {
    LayoutEnum["GREEN"] = "green";
    LayoutEnum["ORANGE"] = "orange";
})(LayoutEnum || (LayoutEnum = {}));

// EXTERNAL MODULE: ./node_modules/formsy-react/dist/formsy-react.esm.js + 67 modules
var formsy_react_esm = __webpack_require__(13235);
// EXTERNAL MODULE: ./node_modules/react-select/dist/react-select.esm.js + 24 modules
var react_select_esm = __webpack_require__(79950);
;// CONCATENATED MODULE: ./src/blocks/CollectingLeads/Form/PhoneNumberInput/countriesWithPrefix.json
var countriesWithPrefix_namespaceObject = JSON.parse('[{"name":"Albania","countryCode":"AL","callingCode":"355"},{"name":"Andorra","countryCode":"AD","callingCode":"376"},{"name":"Austria","countryCode":"AT","callingCode":"43"},{"name":"Belarus","countryCode":"BY","callingCode":"375"},{"name":"Belgium","countryCode":"BE","callingCode":"32"},{"name":"Bosnia and Herzegovina","countryCode":"BA","callingCode":"387"},{"name":"Bulgaria","countryCode":"BG","callingCode":"359"},{"name":"Croatia","countryCode":"HR","callingCode":"385"},{"name":"Cyprus","countryCode":"CY","callingCode":"357"},{"name":"Czech Republic","countryCode":"CZ","callingCode":"420"},{"name":"Denmark","countryCode":"DK","callingCode":"45"},{"name":"Estonia","countryCode":"EE","callingCode":"372"},{"name":"Faroe Islands","countryCode":"FO","callingCode":"298"},{"name":"Finland","countryCode":"FI","callingCode":"358"},{"name":"France","countryCode":"FR","callingCode":"33"},{"name":"Germany","countryCode":"DE","callingCode":"49"},{"name":"Gibraltar","countryCode":"GI","callingCode":"350"},{"name":"Greece","countryCode":"GR","callingCode":"30"},{"name":"Holy See","countryCode":"VA","callingCode":"379"},{"name":"Hungary","countryCode":"HU","callingCode":"36"},{"name":"Iceland","countryCode":"IS","callingCode":"354"},{"name":"Ireland","countryCode":"IE","callingCode":"353"},{"name":"Italy","countryCode":"IT","callingCode":"39"},{"name":"Latvia","countryCode":"LV","callingCode":"371"},{"name":"Liechtenstein","countryCode":"LI","callingCode":"423"},{"name":"Lithuania","countryCode":"LT","callingCode":"370"},{"name":"Luxembourg","countryCode":"LU","callingCode":"352"},{"name":"Macedonia (the former Yugoslav Republic of)","countryCode":"MK","callingCode":"389"},{"name":"Malta","countryCode":"MT","callingCode":"356"},{"name":"Moldova (Republic of)","countryCode":"MD","callingCode":"373"},{"name":"Monaco","countryCode":"MC","callingCode":"377"},{"name":"Montenegro","countryCode":"ME","callingCode":"382"},{"name":"Netherlands","countryCode":"NL","callingCode":"31"},{"name":"Norway","countryCode":"NO","callingCode":"47"},{"name":"Poland","countryCode":"PL","callingCode":"48"},{"name":"Portugal","countryCode":"PT","callingCode":"351"},{"name":"Republic of Kosovo","countryCode":"XK","callingCode":"383"},{"name":"Romania","countryCode":"RO","callingCode":"40"},{"name":"Russian Federation","countryCode":"RU","callingCode":"7"},{"name":"San Marino","countryCode":"SM","callingCode":"378"},{"name":"Serbia","countryCode":"RS","callingCode":"381"},{"name":"Slovakia","countryCode":"SK","callingCode":"421"},{"name":"Slovenia","countryCode":"SI","callingCode":"386"},{"name":"Spain","countryCode":"ES","callingCode":"34"},{"name":"Svalbard and Jan Mayen","countryCode":"SJ","callingCode":"4779"},{"name":"Sweden","countryCode":"SE","callingCode":"46"},{"name":"Switzerland","countryCode":"CH","callingCode":"41"},{"name":"Ukraine","countryCode":"UA","callingCode":"380"},{"name":"United Kingdom of Great Britain and Northern Ireland","countryCode":"GB","callingCode":"44"}]');
;// CONCATENATED MODULE: ./src/blocks/CollectingLeads/Form/PhoneNumberInput/PrefixSelect.tsx





const PrefixSelect = (param)=>{
    let { setValue , value , errorMessage , showErrors , setErrorMessage  } = param;
    const options = countriesWithPrefix_namespaceObject.map((item)=>({
            value: "+".concat(item.callingCode),
            label: "".concat(item.countryCode, " +").concat(item.callingCode)
        }));
    const showError = showErrors && errorMessage;
    (0,react.useEffect)(()=>{
        setErrorMessage(errorMessage);
    }, [
        errorMessage,
        setErrorMessage
    ]);
    (0,react.useEffect)(()=>{
        if (true) {
            const defaultCountry = countriesWithPrefix_namespaceObject.find((prefix)=>"+".concat(prefix.callingCode) === "+383");
            if (defaultCountry) {
                setValue({
                    value: "+".concat(defaultCountry.callingCode),
                    label: "".concat(defaultCountry.countryCode, " +").concat(defaultCountry.callingCode)
                });
            }
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_select_esm/* default */.ZP, {
            instanceId: "prefixSelect",
            classNamePrefix: "Select",
            className: showError ? "Select hasError" : "Select",
            value: value,
            onChange: (event)=>setValue(event ? event : null),
            options: options,
            isSearchable: false,
            isClearable: false
        })
    });
};
/* harmony default export */ var PhoneNumberInput_PrefixSelect = ((0,formsy_react_esm/* withFormsy */.pd)(PrefixSelect));

;// CONCATENATED MODULE: ./src/blocks/CollectingLeads/Form/PhoneNumberInput/PhoneNumberInput.tsx



const PhoneNumberInput = (param)=>{
    let { value , setValue , placeholder , errorMessage , showErrors , setErrorMessage  } = param;
    const showError = showErrors && errorMessage;
    (0,react.useEffect)(()=>{
        setErrorMessage(errorMessage);
    }, [
        errorMessage,
        setErrorMessage
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
        className: showError ? "hasError" : "",
        type: "tel",
        value: value,
        onChange: (event)=>setValue(event.currentTarget.value),
        placeholder: placeholder
    });
};
/* harmony default export */ var PhoneNumberInput_PhoneNumberInput = ((0,formsy_react_esm/* withFormsy */.pd)(PhoneNumberInput));

// EXTERNAL MODULE: ./utils/validators.ts
var validators = __webpack_require__(44624);
;// CONCATENATED MODULE: ./src/blocks/CollectingLeads/Form/PhoneNumberInput/PhoneNumberWithPrefixInput.tsx





const PhoneNumberWithPrefixInput = (param)=>{
    let { label , placeholder , showErrors , required , t  } = param;
    const propsForRequired = ()=>{
        if (required) {
            return {
                required: true,
                validations: {
                    isPhoneValid: validators/* phoneValidator */.tH
                },
                validationErrors: {
                    isDefaultRequiredValue: t("dataForm-requiredValidation"),
                    isPhoneValid: t("dataForm-phoneFormat")
                }
            };
        }
        return {};
    };
    const selectPropsForRequired = ()=>{
        if (required) {
            return {
                required: true,
                validationErrors: {
                    isDefaultRequiredValue: t("dataForm-requiredValidation")
                }
            };
        }
        return {};
    };
    const [errorMessage, setErrorMessage] = (0,react.useState)("");
    const [prefixErrorMessage, setPrefixErrorMessage] = (0,react.useState)("");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "collectingLeads__label",
                children: [
                    label && /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        dangerouslySetInnerHTML: {
                            __html: label
                        }
                    }),
                    (showErrors && errorMessage || showErrors && prefixErrorMessage) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "hasError",
                        children: errorMessage || prefixErrorMessage
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "phoneNumberWithPrefix",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneNumberInput_PrefixSelect, {
                        name: "phone_number_prefix",
                        showErrors: showErrors,
                        setErrorMessage: setPrefixErrorMessage,
                        ...selectPropsForRequired()
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneNumberInput_PhoneNumberInput, {
                        name: "phone_number",
                        showErrors: showErrors,
                        placeholder: placeholder,
                        setErrorMessage: setErrorMessage,
                        ...propsForRequired()
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var PhoneNumberInput_PhoneNumberWithPrefixInput = (PhoneNumberWithPrefixInput);

;// CONCATENATED MODULE: ./src/blocks/CollectingLeads/Form/TextInput/TextInput.tsx



const TextInput = (param)=>{
    let { label , placeholder , showErrors , type , value , setValue , errorMessage  } = param;
    const showError = showErrors && errorMessage;
    const handleOnChange = (event)=>{
        const { value =""  } = event.currentTarget;
        setValue(value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "collectingLeads__label",
                children: [
                    label && /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        dangerouslySetInnerHTML: {
                            __html: label
                        }
                    }),
                    showError && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "hasError",
                        children: errorMessage
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                type: type,
                className: showError ? "hasError" : "",
                value: value,
                onChange: handleOnChange,
                placeholder: placeholder
            })
        ]
    });
};
/* harmony default export */ var TextInput_TextInput = ((0,formsy_react_esm/* withFormsy */.pd)(TextInput));

;// CONCATENATED MODULE: ./src/blocks/CollectingLeads/Form/CollectingSelect/CollectingSelect.tsx




const CollectingSelect = (param)=>{
    let { label , placeholder , showErrors , options , errorMessage , value , setValue  } = param;
    const showError = showErrors && errorMessage;
    const handleOnChange = (event)=>{
        setValue(event ? event : null);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "collectingLeads__label",
                children: [
                    label && /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        dangerouslySetInnerHTML: {
                            __html: label
                        }
                    }),
                    showError && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "hasError",
                        children: errorMessage
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_select_esm/* default */.ZP, {
                instanceId: "collectingLeadsSelect",
                className: showError ? "Select hasError" : "Select",
                classNamePrefix: "Select",
                name: "form-field-name",
                placeholder: placeholder,
                onChange: handleOnChange,
                options: options,
                value: value,
                isClearable: true,
                isSearchable: false
            })
        ]
    });
};
/* harmony default export */ var CollectingSelect_CollectingSelect = ((0,formsy_react_esm/* withFormsy */.pd)(CollectingSelect));

;// CONCATENATED MODULE: ./src/blocks/CollectingLeads/constraints.ts
const MAX_TEXT_AREA_VALUE_LENGTH = 1000;
const UE_EVENT_NAME = "event.lead_www_backup";
const getQuestions = (collectingLeadsData)=>{
    const questionPhrase = "question";
    const requiredPhrase = "Required";
    const maxPhraseLength = 10;
    const questionsArray = [];
    const questionsKeys = Object.keys(collectingLeadsData).filter((key)=>key.startsWith(questionPhrase) && key.length <= maxPhraseLength);
    questionsKeys.forEach((questionKey)=>{
        const name = collectingLeadsData[questionKey];
        if (name) {
            const requiredKey = questionKey + requiredPhrase;
            questionsArray.push({
                name: questionKey,
                label: collectingLeadsData[questionKey],
                required: collectingLeadsData[requiredKey]
            });
        }
    });
    return questionsArray;
};

;// CONCATENATED MODULE: ./src/blocks/CollectingLeads/Form/CollectingTextArea/CollectingTextArea.tsx




const CollectingTextArea = (param)=>{
    let { label , placeholder , showErrors , errorMessage , value , setValue  } = param;
    const showError = showErrors && errorMessage;
    const valueLength = value ? value.length : 0;
    const handleOnChange = (event)=>{
        const value = event.currentTarget.value;
        if (value.length <= MAX_TEXT_AREA_VALUE_LENGTH) {
            setValue(event.currentTarget.value);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "collectingLeads__textAreaContainer",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "collectingLeads__label",
                children: label && /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                    dangerouslySetInnerHTML: {
                        __html: label
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                className: showError ? "hasError" : "",
                value: value,
                onChange: handleOnChange,
                placeholder: placeholder
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "collectingLeads__label",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "hasError",
                    children: showError ? errorMessage : ""
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "text-counter",
                children: [
                    valueLength,
                    "/",
                    MAX_TEXT_AREA_VALUE_LENGTH
                ]
            })
        ]
    });
};
/* harmony default export */ var CollectingTextArea_CollectingTextArea = ((0,formsy_react_esm/* withFormsy */.pd)(CollectingTextArea));

;// CONCATENATED MODULE: ./src/blocks/CollectingLeads/Form/ContentUnderneath/ContentUnderneath.tsx


const ContentUnderneath = (param)=>{
    let { contentUnderneath , contentUnderneathCollapsed , t  } = param;
    const [dropDown, setDropDown] = (0,react.useState)(false);
    const toggleDropDown = ()=>{
        setDropDown(!dropDown);
    };
    return contentUnderneathCollapsed ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "collectingLeads__contentUnderneath",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "collectingLeads__contentUnderneathInfo ".concat(dropDown ? "collectingLeads__contentUnderneathInfo--active" : "collectingLeads__contentUnderneathInfo--notActive"),
                onClick: toggleDropDown,
                dangerouslySetInnerHTML: {
                    __html: contentUnderneath
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                onClick: toggleDropDown,
                className: "collectingLeads__contentUnderneathShowMore",
                children: dropDown ? t("informer-showLess") : t("informer-showMore")
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "collectingLeads__contentUnderneathInfo",
        dangerouslySetInnerHTML: {
            __html: contentUnderneath
        }
    });
};
/* harmony default export */ var ContentUnderneath_ContentUnderneath = (ContentUnderneath);

;// CONCATENATED MODULE: ./src/blocks/CollectingLeads/Form/CollectingCheckbox/CollectingCheckbox.tsx



const CollectingCheckbox = (param)=>{
    let { label , showErrors , value , setValue  } = param;
    const showError = showErrors && !value;
    const handleOnChange = (event)=>{
        const { checked =false  } = event.target;
        setValue(checked);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "collectingLeads__checkbox",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "customCheck".concat(value ? " customCheck--checked" : "").concat(showError ? " hasError" : "")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                    type: "checkbox",
                    checked: value,
                    onChange: handleOnChange
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat(showError ? "hasError" : ""),
                    dangerouslySetInnerHTML: {
                        __html: label
                    }
                })
            ]
        })
    });
};
/* harmony default export */ var CollectingCheckbox_CollectingCheckbox = ((0,formsy_react_esm/* withFormsy */.pd)(CollectingCheckbox));

// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 12 modules
var esm = __webpack_require__(30674);
;// CONCATENATED MODULE: ./src/blocks/CollectingLeads/Form/CollectingLeadsForm.tsx










const CollectingLeadsForm = (param)=>{
    let { data , cities , anchorId , questionsArray , handleSubmit , validationServerErrors  } = param;
    const [hasErrors, setHasErrors] = (0,react.useState)(false);
    const [isSubmitted, setIsSubmitted] = (0,react.useState)(false);
    const formId = anchorId ? anchorId + "_form" : undefined;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const handleValid = ()=>{
        if (hasErrors) {
            setHasErrors(false);
        }
    };
    const handleInvalid = ()=>{
        if (!hasErrors) {
            setHasErrors(true);
        }
    };
    const getTextLabel = function(label) {
        let isRequired = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        return "".concat(t(label)).concat(isRequired ? "*" : "");
    };
    const getDefaultValidationRequired = function() {
        let isRequired = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, message = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "dataForm-requiredValidation";
        return isRequired ? {
            isDefaultRequiredValue: t(message)
        } : undefined;
    };
    const getEmailValidation = function() {
        let isRequired = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, message = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "dataForm-requiredValidation";
        return isRequired ? {
            isDefaultRequiredValue: t(message),
            isEmail: t("dataForm-emailValidation")
        } : undefined;
    };
    const { nameLead , nameLeadRequired , surname , surnameRequired , company , companyRequired , positionLead , positionLeadRequired , email , emailRequired , phone , phoneRequired , buttonText , city , cityRequired , contentUnderneath , contentUnderneathCollapsed , contentForConsent  } = data;
    const showErrors = isSubmitted && hasErrors;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "collectingLeads__form",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(formsy_react_esm/* default */.ZP, {
            onValidSubmit: handleSubmit,
            onValid: handleValid,
            onInvalid: handleInvalid,
            validationErrors: validationServerErrors,
            id: formId,
            children: [
                nameLead && /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput_TextInput, {
                    name: "name",
                    required: nameLeadRequired,
                    placeholder: t("dataForm-name"),
                    label: getTextLabel("dataForm-name", nameLeadRequired),
                    validationErrors: getDefaultValidationRequired(nameLeadRequired),
                    showErrors: showErrors
                }),
                surname && /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput_TextInput, {
                    name: "surname",
                    required: surnameRequired,
                    placeholder: t("dataForm-lastName"),
                    label: getTextLabel("dataForm-lastName", surnameRequired),
                    validationErrors: getDefaultValidationRequired(surnameRequired),
                    showErrors: showErrors
                }),
                company && /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput_TextInput, {
                    name: "company",
                    required: companyRequired,
                    placeholder: t("dataForm-companyName"),
                    label: getTextLabel("dataForm-companyName", companyRequired),
                    validationErrors: getDefaultValidationRequired(companyRequired),
                    showErrors: showErrors
                }),
                positionLead && /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput_TextInput, {
                    name: "position",
                    required: positionLeadRequired,
                    placeholder: t("dataForm-position"),
                    label: getTextLabel("dataForm-position", positionLeadRequired),
                    validationErrors: getDefaultValidationRequired(positionLeadRequired),
                    showErrors: showErrors
                }),
                email && /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput_TextInput, {
                    name: "email",
                    type: "email",
                    required: emailRequired,
                    validations: "isEmail",
                    placeholder: t("dataForm-email"),
                    label: getTextLabel("dataForm-email", emailRequired),
                    validationErrors: getEmailValidation(emailRequired),
                    showErrors: showErrors
                }),
                phone && /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneNumberInput_PhoneNumberWithPrefixInput, {
                    required: phoneRequired,
                    showErrors: showErrors,
                    placeholder: t("dataForm-phone"),
                    t: t,
                    label: getTextLabel("dataForm-phone", phoneRequired)
                }),
                city && /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectingSelect_CollectingSelect, {
                    options: cities,
                    name: "city",
                    required: cityRequired,
                    placeholder: t("dataForm-chooseCity"),
                    label: getTextLabel("dataForm-city", cityRequired),
                    showErrors: showErrors,
                    validationErrors: getDefaultValidationRequired(cityRequired)
                }),
                questionsArray.map((question)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(CollectingTextArea_CollectingTextArea, {
                        name: question.name,
                        required: question.required,
                        label: question.label,
                        showErrors: showErrors,
                        validationErrors: getDefaultValidationRequired(question.required)
                    }, question.name)),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentUnderneath_ContentUnderneath, {
                    contentUnderneath: contentUnderneath,
                    contentUnderneathCollapsed: contentUnderneathCollapsed,
                    t: t
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectingCheckbox_CollectingCheckbox, {
                    name: "acceptence",
                    label: contentForConsent,
                    showErrors: showErrors,
                    validations: "isTrue",
                    required: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    onClick: ()=>setIsSubmitted(true),
                    type: "submit",
                    className: "modern-button modern-button-primary",
                    disabled: showErrors,
                    children: buttonText
                })
            ]
        })
    });
};
/* harmony default export */ var Form_CollectingLeadsForm = (CollectingLeadsForm);

// EXTERNAL MODULE: ./utils/CitiesContext.tsx
var CitiesContext = __webpack_require__(8851);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./utils/HttpClient.ts
var HttpClient = __webpack_require__(4866);
// EXTERNAL MODULE: ./utils/gtmEvents.ts
var gtmEvents = __webpack_require__(38077);
// EXTERNAL MODULE: ./utils/UserEngageProvider.ts
var UserEngageProvider = __webpack_require__(51635);
;// CONCATENATED MODULE: ./src/blocks/CollectingLeads/CollectingLeads.tsx










const CollectingLeads = (param)=>{
    let { blockData  } = param;
    const { data , id: blockId  } = blockData;
    const [formSent, setFormSent] = (0,react.useState)(false);
    const { postContent , layout , picture , title , lead , anchorId =""  } = data;
    const isOrangeLayout = LayoutEnum.ORANGE === layout;
    const questionsArray = getQuestions(data);
    const { cities  } = (0,CitiesContext/* useCitiesState */.$)();
    const getBackground = ()=>{
        return {
            background: !isOrangeLayout ? "url(".concat(picture && picture.publicUrl ? "https://www-api.coderslabkosova.com/" + picture.publicUrl : "/blocks/CollectingLeads/green-background.svg", ")") : "none",
            backgroundRepeat: "no-repeat",
            backgroundPositionX: "center",
            backgroundSize: "cover"
        };
    };
    const sendLead = async (data)=>{
        const phone = "".concat((0,lodash.get)(data, "phone_number_prefix.value", "")).concat((0,lodash.get)(data, "phone_number"));
        const currentUrl = window.location.href;
        const city = (0,lodash.get)(data, "city.label", "");
        const email = (0,lodash.get)(data, "email", "");
        const name = (0,lodash.get)(data, "name", "");
        const surname = (0,lodash.get)(data, "surname", "");
        const emailDetails = {
            ...data,
            city,
            blockId,
            phone_number: phone,
            src_url: currentUrl
        };
        const popupName = anchorId;
        if (blockId) {
            await (0,HttpClient/* sendLead */.Wb)(emailDetails);
        }
        (0,gtmEvents/* collectingLeadsSendWithData */.SM)(anchorId, email, city, phone, currentUrl);
        (0,gtmEvents/* collectingLeadsSend */.sM)();
        let pageHitEventData = {
            email: data.email,
            phone_number: phone,
            miasto_kursu: city ? city : "Online",
            lead_form: popupName,
            lead_source: "WWW",
            question_1: data.question1,
            question_2: data.question2,
            question_3: data.question3,
            question_4: data.question4
        };
        let leadEventData = {
            email: data.email,
            phone_number: phone,
            miasto_kursu: city ? city : "Online",
            formularz: popupName,
            url: currentUrl,
            question1: data.question1,
            question2: data.question2,
            question3: data.question3,
            question4: data.question4
        };
        if (name) {
            pageHitEventData = {
                ...pageHitEventData,
                first_name: name
            };
            leadEventData = {
                ...leadEventData,
                first_name: name
            };
        }
        if (surname) {
            pageHitEventData = {
                ...pageHitEventData,
                last_name: surname
            };
            leadEventData = {
                ...leadEventData,
                last_name: surname
            };
        }
        UserEngageProvider/* default.pageHit */.Z.pageHit(window, pageHitEventData);
        UserEngageProvider/* default.eventWithName */.Z.eventWithName(window, UE_EVENT_NAME, leadEventData);
        setFormSent(true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: anchorId,
        className: "collectingLeads".concat(isOrangeLayout ? " layout-orange" : " layout-green"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: getBackground(),
                className: "collectingLeads__backgroundImage"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "desktop-container collectingLeads__container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "infoSection",
                        children: [
                            title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "collectingLeads__title",
                                children: title
                            }),
                            lead && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "collectingLeads__leadContent",
                                dangerouslySetInnerHTML: {
                                    __html: lead
                                }
                            })
                        ]
                    }),
                    formSent ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "".concat(anchorId, "-submitted"),
                        className: "collectingLeads__postContent",
                        dangerouslySetInnerHTML: {
                            __html: postContent
                        }
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "collectingLeads__formContainer",
                        children: [
                            isOrangeLayout && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "plane-lines-orangeImg",
                                alt: "plane-lines",
                                src: "/blocks/CollectingLeads/orange_bg.svg"
                            }),
                            !isOrangeLayout && (!picture || !picture.publicUrl) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: "plane-img",
                                        src: "/blocks/CollectingLeads/plane.svg",
                                        alt: "plane"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: "plane-lines-img",
                                        src: "/blocks/CollectingLeads/lines.svg",
                                        alt: "plane-lines"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_CollectingLeadsForm, {
                                validationServerErrors: {},
                                data: data,
                                cities: cities.map((city)=>({
                                        value: city.cityNormalized,
                                        id: city.id,
                                        label: city.name
                                    })),
                                questionsArray: questionsArray,
                                handleSubmit: sendLead,
                                anchorId: anchorId
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var CollectingLeads_CollectingLeads = (CollectingLeads);

;// CONCATENATED MODULE: ./src/blocks/CollectingLeads/index.ts



/***/ }),

/***/ 51635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(83454);
class UserEngageProvider {
    static isAvailable(window) {
        return !!this.userEngageApiKey && window !== undefined && !!window.userengage && !!window.UE;
    }
    static pageHit(window, data) {
        var _window_UE;
        (_window_UE = window.UE) === null || _window_UE === void 0 ? void 0 : _window_UE.pageHit({
            apiKey: this.userEngageApiKey,
            ...data
        });
    }
    static eventWithName(window, eventName, data) {
        var _window_userengage;
        (_window_userengage = window.userengage) === null || _window_userengage === void 0 ? void 0 : _window_userengage.call(window, eventName, {
            apiKey: this.userEngageApiKey,
            ...data
        });
    }
}
UserEngageProvider.userEngageApiKey = process.env.NEXT_PUBLIC_UE_KEY;
UserEngageProvider.UE_EVENT_NAME = "event.lead_www_backup";
UserEngageProvider.LEAD_SOURCE_VALUE = "WWW";
/* harmony default export */ __webpack_exports__["Z"] = (UserEngageProvider);


/***/ })

}]);